import axios from '@/axios.config.js';

class ShopService {
    createCategory(cancelToken, categoryObj) {
        return axios
            .post('shop/categories', {
                title: categoryObj.title,
                image_id: categoryObj.image_id,
                description: categoryObj.description,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateCategory(cancelToken, categoryObj) {
        return axios
            .patch(`shop/categories/${categoryObj.id}`, {
                title: categoryObj.title,
                image_id: categoryObj.image_id,
                description: categoryObj.description,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteCategory(cancelToken, categoryId) {
        return axios
            .delete(`shop/categories/${categoryId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getCategory(cancelToken, categoryId) {
        return axios
            .get(`shop/categories/${categoryId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listCategories(cancelToken) {
        return axios
            .get('/admin/shop/categories', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    createProduct(cancelToken, productObj) {
        return axios
            .post('shop/products', {
                name: productObj.name,
                category_id: productObj.category_id,
                course_id: productObj.course_id,
                price: parseInt(productObj.price),
                discount: parseInt(productObj.discount),
                capacity: parseInt(productObj.capacity),
                image_id: productObj.image_id,
                description: productObj.description,
                status: productObj.status === "1",
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateProduct(cancelToken, productObj) {
        return axios
            .patch(`shop/products/${productObj.id}`, {
                name: productObj.name,
                category_id: productObj.category_id,
                course_id: productObj.course_id,
                price: parseInt(productObj.price),
                discount: parseInt(productObj.discount),
                capacity: parseInt(productObj.capacity),
                image_id: productObj.image_id,
                description: productObj.description,
                status: productObj.status,
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteProduct(cancelToken, productId) {
        return axios
            .delete(`shop/products/${productId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getProduct(cancelToken, productId) {
        return axios
            .get(`shop/products/${productId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listProducts(cancelToken) {
        return axios
            .get('/admin/shop/products', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listOrders(cancelToken, productId) {
        return axios
            .get(`shop/products/${productId}/orders`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getProductLanding(cancelToken, productId) {
        return axios
            .get(`products/${productId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    createOrder(cancelToken, productId) {
        return axios
            .post(`orders`, {product_ids: [productId],}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listCategoriesLanding(cancelToken) {
        return axios
            .get('categories', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listProductsLanding(cancelToken) {
        return axios
            .get('products', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    getOrders(cancelToken) {
        return axios
            .get(`shop/orders`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

}

export default new ShopService();
